import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FirestoreService } from '../../data/firestore.service';
import { DialogComponent } from '../dialog/dialog/dialog.component';

@Component({
  selector: 'app-motive',
  templateUrl: './motive.component.html',
  styleUrls: [
    '../../../secure/styles/forms.scss',
    './motive.component.scss',
  ]
})
export class MotiveComponent implements OnInit {
  @ViewChild('dialog') dialogRef: DialogComponent;
    public cardDataExtra;
  constructor(
    private firestore: FirestoreService,
  ) { }

  form: FormGroup// = new FormGroup({
  //   motive: new FormControl('', { validators: [Validators.required] }),
  //   observation: new FormControl('', {validators: [Validators.maxLength(500)]})
  // })
  type: string //= 'RESET_PIN' //TODO cambiar por parametro de entrada
  motives = {}
  motiveCodes = []
  auxMotiveCodes = []


  ngOnInit() {
    this.load()
  }

  load() {
    this.form = new FormGroup({
      motive: new FormControl('', { validators: [Validators.required] }),
      observation: new FormControl('', {validators: [Validators.maxLength(500)]})
    })
    let other
    //Get dominio
    this.firestore.doc('domain/motives').subscribe(motives => {
        this.motiveCodes = [];
      this.auxMotiveCodes = Object.keys(motives[this.type])
      this.motives = Object.assign({}, this.motives, motives[this.type])
      this.auxMotiveCodes.sort((a, b) => b.localeCompare(a));
        console.log(this.auxMotiveCodes);
        this.auxMotiveCodes.forEach(motive => {
        if (motive === 'OTHER') {
           other = motive;
        } else {
          if (this.motiveCodes.indexOf(motive) === -1) {
            this.motiveCodes.push(motive);
          }
        }
      });
      if (other && this.motiveCodes.indexOf(other) === -1 ) {
        this.motiveCodes.push(other)
      }
        console.log(this.motiveCodes);
    })
  }

  get motive() {
    return this.form.get('motive')
  }

  get observation() {
    return this.form.get('observation')
  }

  show() {
    this.load()
    this.form.get('motive').setValue('')
    this.form.get('observation').setValue('')
    return this.dialogRef.show().catch()
  }

  sendMotive() {
    console.log('sendMotive')
    //validar datos

    //cerrar el modal y enviar datos
    const motive = {
      motive: this.form.get('motive').value,
      observation: this.form.get('observation').value,
        reference: this.motives[this.form.get('motive').value]
    }

    console.log('motive', motive)
    console.log('motive', this.motives)
    this.dialogRef.confirm(motive)
  }

  reset() {
    console.log('reset')
    this.dialogRef.cancel()
  }
}
